import React, { Fragment, useRef, useState } from 'react';
import { styled, Table, TableBody, TableRow } from '@mui/material';
import MuiTableHead from './MuiTableHead';
import { defaultComparator } from '@lib/utils';

const MuiTable = ({
  defaultOrderBy,
  defaultOrderDir,
  headCells,
  getComparator = defaultComparator,
  data,
  spinner,
  alignTop = false,
  children,
}) => {
  const [order, setOrder] = useState(defaultOrderDir || 'asc');
  const [orderBy, setOrderBy] = useState(defaultOrderBy);

  const headRef = useRef(null);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
    setTimeout(() => {
      const sorter = headRef.current?.querySelector(`#${property}`);
      sorter.focus()
    }, 10);
  };

  const rows = React.useMemo(
    () => data ? [...data].sort(getComparator(order, orderBy)) : null,
    [data, getComparator, order, orderBy],
  );

  const StyledTable = styled(Table)(({ theme }) => ({
    '.MuiTableRow-head .MuiTableCell-head': {
      backgroundColor: theme.palette['light-grey'].main,
    },
  }));

  const renderRowChildren = (row) => {
    const childRow = children(row);
    if (Array.isArray(childRow)) {
      return childRow.map((child, index) => (
        <Fragment key={`${row.id}-${index}-${child.id}`}>
          { child }
        </Fragment>
      ));
    }
    return childRow;
  };

  return (
    <StyledTable
      aria-labelledby="events-table"
      size="medium"
      sx={{
        backgroundColor: 'black',
        color: 'blue',
        '& .MuiTableRow-head .MuiTableCell-head': {
          backgroundColor: 'black',
          color: 'blue',
        },
        ...(alignTop ? {
          '& .MuiTableCell-root': {
            verticalAlign: 'top',
          }
        } : {}),
      }}
    >
      <MuiTableHead
        headCells={headCells}
        order={order}
        orderBy={orderBy}
        onRequestSort={handleRequestSort}
        noWrap
        ref={headRef}
      />
      <TableBody>
        {(!spinner || rows !== null) && rows.map((row) => (
          <TableRow
            hover
            tabIndex={-1}
            key={row.id}
          >
            { renderRowChildren(row) }
          </TableRow>
        ))}
      </TableBody>
    </StyledTable>
  );
};

export default MuiTable;
